export default "__VITE_ASSET__8SbnDqFn__"